import { message, notification, PageHeader, Popconfirm, Space, Tag, Tooltip } from "antd";
import axios from "axios";
import React, { Component } from "react";
import moment from "moment";
import "moment/locale/es";
import { connect } from "react-redux";
import { ButtonItem, SegmentedItem, TableItemDinamico, dineroDisabledMask } from "../../../Components/Items";
import { CloseCircleOutlined, BookFilled, SearchOutlined, FileProtectOutlined } from "@ant-design/icons";
import MandarCorreoNotaDeCreditoVenta from "../NotasDeCreditoVenta/MandarCorreoNotaDeCreditoVenta/MandarCorreoNotaDeCreditoVenta";
import CancelarNotaDeCreditoVenta from "./CancelarNotaDeCreditoVenta/CancelarNotaDeCreditoVenta";
import ModalAcuseCancelacionNota from "./ModalAcuseCancelacionNota/ModalAcuseCancelacionNota";
import { obtenerEstadoCancelacion } from "../../../Utils/estatusSat.utils";

moment.locale("es");
class NotasDeCreditoVenta extends Component {
  tableRef = null;
  state = {
    todasNotasDeCredito: [],
    loading: false,
    totalRecords: 0,
    valor: 0,
    modalCorreo: false,
    modalCorreoId: null,
    modalCancelarNotaDeCreditoVenta: false,
    modalCancelarNotaDeCreditoVentaId: null,
    modalAcuseCancelacion: false,
    modalAcuseCancelacionId: null,
  };

  consultarNotasDeCredito(params) {
    this.setState({ loading: true });
    axios
      .post(
        "notasDeCreditoVenta/selectNotasVenta",
        { empresaId: this.props.empresaId, ...params },
        {
          headers: this.props.headersToken,
        }
      )
      .then((res) => {
        if (res.data.success === 2) {
          this.setState({
            todasNotasDeCredito: res.data.data.map((value) => {
              return {
                ...value,
                fechaNota: value.fechaNota ? value.fechaNota : value.createdAt,
                accion: { _id: value._id, estado: value.estado, notaId: value._id, cancelacion: value.cancelacion, factura: value.factura },
              };
            }),
            totalRecords: res.data.totalRecords || 0,
            loading: false,
          });
        } else {
          this.setState({ todasNotasDeCredito: [], loading: false, totalRecords: 0 });
        }
      })
      .catch((err) => {
        this.setState({ loading: false });
        message.error("Error al consultar las notas credito");
        console.log(err);
      });
  }


  enviarNota(value) {
    this.setState({ modalCorreo: true, modalCorreoId: value });
  }

  cerrarMandarCorreoNotaDeCreditoVenta() {
    this.setState({
      modalCorreo: false,
      modalCorreoId: null,
    });
  }

  cerrarCancelarNotaDeCreditoVenta() {
    this.setState({
      modalCancelarNotaDeCreditoVenta: false,
      modalCancelarNotaDeCreditoVentaId: null,
    });
    if (this.tableRef) {
      this.tableRef.updateExternalFilters({ valor: this.state.valor });
    }
  }

  cerrarAcuseCancelacion() {
    this.setState({
      modalAcuseCancelacion: false,
      modalAcuseCancelacionId: null,
    });
  }

  agregarNotaDeCreditoGeneral() {
    this.props.history.push("/panel/agregarNotaDeCreditoVentaGeneral");
  }

  checarEstatusFiscalNota(notaId) {
    this.setState({ loading: true });
    axios
      .post("notasDeCreditoVenta/checarEstatusFiscalNotaDeCredito", { notaId, empresaId: this.props.empresaId }, { headers: this.props.headersToken })
      .then((res) => {
        this.setState({ loading: false });
        if (res.data.success === 2 && res.data.cancelada) {
          message.success(res.data.message);
        } else if (res.data.success === 2) {
          message.info(res.data.message);
        } else if (res.data.success === 3) {
          notification.info({ message: "Ya estaba cancelada", description: res.data.message });
        } else {
          notification.error({ message: "Error", description: res.data.message || "No se pudo consultar el estatus fiscal" });
        }
        if (this.tableRef) {
          this.tableRef.updateExternalFilters({ valor: this.state.valor });
        }
      })
      // Sin este catch, un timeout o un 500 dejaba `loading: true` colgado y la tabla en
      // spinner para siempre. Y el SAT es justo un servicio que se cae seguido.
      .catch(() => {
        this.setState({ loading: false });
        notification.error({
          message: "Error",
          description: "No se pudo consultar el estatus fiscal en el SAT. Intenta de nuevo en unos minutos.",
        });
      });
  }

  render() {
    const columns = [
      {
        title: "Folio / OC",
        dataIndex: "folio",
        key: "folio",
        buscar: "folio",
        render: (_, record) => {
          let satColor = null;
          let satTooltip = null;
          if (record.factura) {
            if (record.estado === 0) {
              if (record?.cancelacion?.statusCancelacion === 1) {
                satColor = "#fa8c16";
                satTooltip = `SAT: Cancelación en proceso (${obtenerEstadoCancelacion(record?.cancelacion?.estadoCancelacion)})`;
              } else if (record?.cancelacion?.statusCancelacion === 2) {
                satColor = "#1E88E5";
                satTooltip = "SAT: Cancelado";
              } else if (record?.cancelacion?.statusCancelacion === 3) {
                satColor = "#d4b106";
                satTooltip = "SAT: Rechazada";
              } else {
                satColor = "#999999";
                satTooltip = "SAT: Sin información";
              }
            } else {
              satColor = "#52c41a";
              satTooltip = "SAT: Vigente";
            }
          }

          return (
            <div>
              <div style={{ fontSize: "12px", display: "flex", alignItems: "center", gap: "4px" }}>
                <span>{record.folio}</span>
                {satColor && (
                  <Popconfirm
                    title="Se consultará el estatus real de esta nota de crédito en el SAT. Si aparece cancelada, se aplicará la cancelación en el sistema. ¿Continuar?"
                    onConfirm={() => this.checarEstatusFiscalNota(record._id)}
                    okText="Sí"
                    cancelText="No"
                  >
                    <Tooltip title={satTooltip}>
                      <SearchOutlined style={{ color: satColor, cursor: "pointer" }} />
                    </Tooltip>
                  </Popconfirm>
                )}
              </div>
              {record.ordenDeCompra && (
                <div style={{ fontSize: "12px", color: "#666" }}>
                  OC: {record.ordenDeCompra}
                </div>
              )}
            </div>
          );
        },
        width: "12%",
        ellipsis: true,
      },
      {
        title: "OC",
        dataIndex: "ordenDeCompra",
        key: "ordenDeCompra",
        buscar: "ordenDeCompra",
        responsive: [],
        width: 0,
      },
      {
        title: "Ventas relacionadas",
        dataIndex: "ventasFolios",
        key: "ventasFolios",
        width: "14%",
        render: (value) => {
          const lista = Array.from(new Set(value || []))
            .filter(Boolean)
            .sort((a, b) => a.localeCompare(b, "es", { numeric: true }));
          if (lista.length === 0) return "-";
          return (
            <div style={{ fontSize: "12px", whiteSpace: "normal", wordBreak: "break-word" }}>
              {lista.join(", ")}
            </div>
          );
        },
      },
      {
        title: "Cliente / Vendedor",
        dataIndex: "cliente",
        key: "cliente",
        buscar: "cliente",
        width: "16%",
        ellipsis: true,
        render: (_, record) => (
          <>
            {record.cliente || "-"}
            <br />
            <span style={{ color: "#666" }}>
              Vendedor: {record.vendedor || "-"}
            </span>
          </>
        ),
      },
      {
        title: "Vendedor",
        dataIndex: "vendedor",
        key: "vendedor",
        buscar: "vendedor",
        responsive: [],
        width: "0",
      },
      {
        title: "Fecha",
        dataIndex: "fechaNota",
        key: "fechaNota",
        defaultSortOrder: "descend",
        sorter: true,
        render: (value) => moment(value).locale("es").format("DD/MM/YY HH:mm"),
        width: "10%",
        ellipsis: true,
        align: "center",
      },
      {
        title: "Subtotal / Total",
        dataIndex: "subtotal",
        key: "subtotal",
        responsive: ["md"],
        sorter: true,
        buscar: "subtotal",
        render: (_, record) => (
          <div style={{ textAlign: "right" }}>
            <div style={{ fontSize: "12px", color: "#666" }}>
              {dineroDisabledMask(record.subtotal)} {record.moneda}
            </div>
            <div style={{ fontWeight: "bold", fontSize: "12px" }}>
              {dineroDisabledMask(record.totalPagar)} {record.moneda}
            </div>
          </div>
        ),
        width: "12%",
        ellipsis: true,
        align: "right",
      },
      {
        title: "Saldo Pendiente",
        dataIndex: "saldoPendiente",
        key: "saldoPendiente",
        align: "right",
        render: (value, record) => {
          if (record.estado === 0) return ""
          return (
            <div style={{ textAlign: "right", fontWeight: "bold" }}>
              {dineroDisabledMask(record.totalPagar - record.totalPagado)} {record.moneda}
            </div>
          );
        },
        width: "12%",
      },
      {
        title: "Estado",
        dataIndex: "estado",
        key: "estado",
        responsive: ["md"],
        render: (value, record) => {
          if (value === 1) {
            return <Tag color="green" className="square-tag">Vigente</Tag>;
          }
          if (value === 0) {

            let satTag = null;
            if (record.factura) {
              if (record?.cancelacion?.statusCancelacion === 1) {
                satTag = (
                  <Tooltip title={`Estado: ${obtenerEstadoCancelacion(record?.cancelacion?.estadoCancelacion)}`}>
                    <Tag color="orange" className="square-tag">SAT: Cancelación en proceso</Tag>
                  </Tooltip>
                );
              } else if (record?.cancelacion?.statusCancelacion === 2) {
                satTag = (
                  <Tooltip title={`Estado: ${obtenerEstadoCancelacion(record?.cancelacion?.estadoCancelacion)}`}>
                    <Tag color="blue" className="square-tag">SAT: Cancelado</Tag>
                  </Tooltip>
                );
              } else if (record?.cancelacion?.statusCancelacion === 3) {
                satTag = (
                  <Tooltip title={`Estado: ${obtenerEstadoCancelacion(record?.cancelacion?.estadoCancelacion)}`}>
                    <Tag color="yellow" className="square-tag">SAT: Rechazada</Tag>
                  </Tooltip>
                );
              } else {
                satTag = (
                  <Tag color="gray" className="square-tag">SAT: Sin Información</Tag>
                );
              }
            }

            return (
              <div style={{ display: "flex", flexDirection: "column", gap: "4px", alignItems: "flex-start" }}>
                <Tag color="red" className="square-tag">Cancelada</Tag>
                {satTag}
              </div>
            );
          }
        },
        width: "10%",
        ellipsis: true,
      },
      {
        title: "Acción",
        dataIndex: "accion",
        key: "accion",
        fixed: "right",
        width: "7%",
        align: "center",
        onCell: () => ({
          className: "acciones-sin-hover",
        }),
        render: (value, index) => {
          if (value.estado === 0) {
            let buttons = [];

            buttons.push(
              <Tooltip title="Ver PDF" placement="top" key={`ver-pdf-${value._id}`}>
                <ButtonItem
                  type="default"
                  size="small"
                  lila
                  icon={<BookFilled />}
                  onClick={() => this.enviarNota(value._id)}
                >
                </ButtonItem>
              </Tooltip>
            );

            buttons.push(
              <Tooltip title="Acuse de cancelación" placement="top" key={`acuse-${value._id}`}>
                <ButtonItem
                  type="default"
                  size="small"
                  naranja
                  icon={<FileProtectOutlined />}
                  onClick={() =>
                    this.setState({
                      modalAcuseCancelacion: true,
                      modalAcuseCancelacionId: value._id,
                    })
                  }
                />
              </Tooltip>
            );

            if (value.factura && value?.cancelacion?.statusCancelacion === 3) {
              buttons.push(
                <Popconfirm
                  key={`recancelar-${value._id}`}
                  title="¿Cancelar nuevamente el timbre fiscal?"
                  onConfirm={() =>
                    this.setState({
                      modalCancelarNotaDeCreditoVenta: true,
                      modalCancelarNotaDeCreditoVentaId: value._id,
                    })
                  }
                  okText="Sí"
                  cancelText="No"
                >
                  <Tooltip title="Reintentar cancelación SAT" placement="top">
                    <CloseCircleOutlined style={{ color: "red", fontSize: 18 }} />
                  </Tooltip>
                </Popconfirm>
              );
            }

            return <Space direction="horizontal">{buttons}</Space>;
          }

          let buttons = [];

          buttons.push(
            <Tooltip title="Ver PDF" placement="top">
              <ButtonItem
                key={`ver-pdf-${value._id}`}
                type="default"
                size="small"
                lila
                icon={<BookFilled />}
                onClick={() => this.enviarNota(value._id)}
              >
              </ButtonItem>
            </Tooltip>
          );

          buttons.push(
            <Popconfirm
              key={`cancelar-${value._id}`}
              title="¿Seguro que quieres cancelar esta nota de crédito?"
              onConfirm={() => {
                this.setState({
                  modalCancelarNotaDeCreditoVenta: true,
                  modalCancelarNotaDeCreditoVentaId: value._id,
                });
              }}
              okText="Sí"
              cancelText="No"
            >
              <Tooltip title="Cancelar" placement="top">
                <ButtonItem
                  type="default"
                  size="small"
                  rojo
                  icon={<CloseCircleOutlined />}
                >
                </ButtonItem>
              </Tooltip>
            </Popconfirm>
          );

          return <Space direction="horizontal">{buttons}</Space>;
        },
      },
    ];
    return (
      <>
        <PageHeader
          title="Notas de Crédito Venta"
          style={{
            border: "1px solid rgb(235, 237, 240)",
            backgroundColor: "white",
            marginBottom: 10,
          }}
          extra={
            <div className="header-actions">
              {window.innerWidth > 1000 && (
                <>
                  <SegmentedItem
                    options={[
                      { label: "Vigentes", value: 1 },
                      { label: "Canceladas", value: 2 },
                      { label: "Todos", value: 0 },
                    ]}
                    onChange={(value) => {
                      if (this.tableRef) {
                        this.tableRef.updateExternalFilters({ valor: value });
                      }
                      this.setState({ valor: value });
                    }}
                    value={this.state.valor}
                  />
                  <div className="header-divider"></div>
                </>
              )}
              <ButtonItem
                type="primary"
                key="agregarNotaDeCreditoGeneral"
                onClick={this.agregarNotaDeCreditoGeneral.bind(this)}
                className="botonAgregar"
                olivo
              >
                Agregar Nota de Crédito General
              </ButtonItem>
            </div>
          }
        />
        <TableItemDinamico
          ref={(ref) => (this.tableRef = ref)}
          onRef={(ref) => (this.tableRef = ref)}
          totalRecords={this.state.totalRecords}
          onRow={(record, rowIndex) => {
            return {
              onDoubleClick: (event) => {
                this.props.history.push("/panel/verNotaDeCreditoVenta", {
                  id: record._id,
                });
              },
            };
          }}
          anadirValorFiltro={this.state.valor}
          onFetchData={this.consultarNotasDeCredito.bind(this)}
          loading={this.state.loading}
          size="small"
          dataSource={this.state.todasNotasDeCredito}
          columns={columns}
          filterStorageKey={
            "notasDeCreditoVentasFiltrosTabla" + this.props.empresaId
          }
          pagination={false}
          setValor={(valor) => this.setState({ valor })}
          valorDefault={0}
        />
        <MandarCorreoNotaDeCreditoVenta
          visible={this.state.modalCorreo}
          id={this.state.modalCorreoId}
          cerrarMandarCorreoNotaDeCreditoVenta={this.cerrarMandarCorreoNotaDeCreditoVenta.bind(
            this
          )}
        />
        <CancelarNotaDeCreditoVenta
          visible={this.state.modalCancelarNotaDeCreditoVenta}
          id={this.state.modalCancelarNotaDeCreditoVentaId}
          cerrarCancelarNotaDeCreditoVenta={this.cerrarCancelarNotaDeCreditoVenta.bind(
            this
          )}
        />
        <ModalAcuseCancelacionNota
          visible={this.state.modalAcuseCancelacion}
          notaId={this.state.modalAcuseCancelacionId}
          cerrarModalPdf={this.cerrarAcuseCancelacion.bind(this)}
        />
      </>
    );
  }
}

const mapStateToProps = (state) => {
  return {
    headersToken: state.user.headersToken,
    empresaId: state.empresa.id,
    permisoFacturaGlobal:
      state.user.tipo === 0 ||
      state.user.permisos.find(
        (valueTodos) =>
          valueTodos.permisoId.toString() === "6750916e798d4e0043687240"
      )?.activado,
  };
};

export default connect(mapStateToProps)(NotasDeCreditoVenta);